import React from 'react';
import { useTranslation } from 'react-i18next';
import { Bot } from 'lucide-react';
import { providerMeta } from '../../services/ai/aiSettings';
import './aiApiboo.css';

/**
 * EU AI Act Art. 50(1) (applies since 2 Aug 2026): the person must be told
 * they are interacting with an AI system, clearly and at the latest at the
 * first interaction (Art. 50(5)). This is that notice — a short, PERMANENT line
 * under the composer, in both modes (Apiboo AI and bring-your-own-key), never
 * dismissible, and a live `note` that screen readers read.
 *
 * It replaces the 16.09.2026 decision to drop the old "AI-generated, can be
 * wrong" line on the strength of the "obvious" exception (panel title "AI
 * Assistant", composer "Ask the AI assistant…"). The Commission's Art. 50 FAQ
 * says that exception is to be interpreted RESTRICTIVELY, and this assistant
 * is also an agent: it runs tools and writes documents, boards and requests,
 * so its output reaches places where nobody sees the panel title. Relying on
 * the exception is arguable; a one-line notice is not. Wording: "AI Act —
 * AI-generated content disclosure (Art. 50)", § 7.
 *
 * Do not make it one-time or dismissible, and do not fold it into a tooltip:
 * the obligation is a notice the user cannot miss, not one they could find.
 */
export function disclosureKey(readiness) {
  if (readiness?.via === 'apiboo') return { key: 'aiChat.disclosure.apiboo' };
  if (readiness?.via === 'byo' && readiness?.provider) {
    return { key: 'aiChat.disclosure.byo', params: { provider: providerMeta(readiness.provider).label } };
  }
  return { key: 'aiChat.disclosure.generic' };
}

function AiDisclosureLine({ readiness }) {
  const { t } = useTranslation();
  const { key, params } = disclosureKey(readiness);
  return (
    <p className="ai-disclosure-line" role="note" data-testid="ai-disclosure-line">
      <Bot size={11} className="ai-disclosure-line__icon" aria-hidden />
      <span>{t(key, params)}</span>
    </p>
  );
}

export default AiDisclosureLine;
